import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { HcMedicalTestHdrContainerModel } from '../../../../../models/aggregates/healthcare/medical_test_hdr_container.model';

@Injectable({ providedIn: 'root' })
export class HcMedicalTestHdrService extends BaseApiTemplateService<HcMedicalTestHdrContainerModel> {
    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + "medical-test-hdrs";

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'medical-test-hdrs' + '/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'medical-test-hdrs' + '/backoffice-ep';
        this.httpClient = http;
    }
}